export default __webpack_public_path__ + "static/media/fco.093eef83.png";